import React, { useState, useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchHackathons,
  fetchMentors,
  fetchJudges,
  fetchSponsors,
  fetchPrizes,
} from '../../../redux/actions/action';
import Table from '../../../components/tableComponents/Table';
import Dropdown from '../../../components/dropdown/DropDown';
import ViewHackathonModal from './HackathonDetailModal';
import HackathondeleteModal from './HackathondeleteModal';
import HackathonForm from './HackathonForm';
import { fetchAgenda } from '../../../redux/actions/action';
import { deleteHackathon } from '../../../redux/actions/action';



import HackathonEditForm from './HackathonEditform';

const HackathonEventDetails = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
   const [showDeleteModal, setShowDeleteModal] = useState(false);
   const [showEditModal, setShowEditModal] = useState(false);

  const dispatch = useDispatch();

  const hackathons = useSelector((state) => state.hackathons.hackathons || []);
  const mentors = useSelector((state) => state.mentors.mentors || []);
  const judges = useSelector((state) => state.judges.judges || []);
  const sponsors = useSelector((state) => state.sponsors.sponsors || []);
  const { firstPrize, secondPrize, otherPrizes, totalprizes } = useSelector(
    (state) => state.prizes
  );
  const agendas = useSelector(state => state.agenda.agendas);
  //const agendasWithId = useSelector((state) => state.fetchAllAgendas.agendasWithId);

  useEffect(() => {
    dispatch(fetchHackathons());
    dispatch(fetchMentors());
    dispatch(fetchJudges());
    dispatch(fetchSponsors());
  }, [dispatch]);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  const openDetailModal = (event) => {
    setSelectedEvent(event);
    setShowDetailModal(true);
    dispatch(fetchPrizes(event.id));
    dispatch(fetchAgenda(event.id));
  };

  const openDeleteModal = (event) => {
    setSelectedEvent(event);
    setShowDeleteModal(true);
  };

  const openEditModal = (event) => {
    setSelectedEvent(event);
    dispatch(fetchPrizes(event.id));
  dispatch(fetchAgenda(event.id));
    setShowEditModal(true);
  };


  const closeDetailModal = () => {
    setShowDetailModal(false);
    // Optional: dispatch({ type: 'CLEAR_PRIZES' });
  };

  const handleFormSubmit = () => {
    alert('Hackathon event added successfully!');
    closeForm();
  };

  const getMentorNames = (hackathonId) =>
    mentors
      .filter((mentor) => mentor.hackathon_form_id === hackathonId)
      .map((mentor) => mentor.name)
      .join(', ');

  const getJudgeNames = (hackathonId) =>
    judges
      .filter((judge) => judge.hackathon_form_id === hackathonId)
      .map((judge) => judge.name)
      .join(', ');

  const columns = useMemo(
    () => [
      { Header: 'Event Name', accessor: 'eventName' },
      { Header: 'Project Details', accessor: 'projectDetails' },
      { Header: 'Technology', accessor: 'technology' },
      { Header: 'Team Formation', accessor: 'teamFormation' },
      {
        Header: 'Mentors',
        accessor: (row) => getMentorNames(row.id),
      },
      {
        Header: 'Judges',
        accessor: (row) => getJudgeNames(row.id),
      },
      {
        Header: 'Actions',
        accessor: 'actions',
        Cell: ({ row }) => (
          <Dropdown
            options={['View', 'Edit', 'Delete']}
            onSelect={(option) => {
              if (option === 'View') openDetailModal(row.original);
              if (option === 'Edit') console.log('Edit clicked:', row.original);
              if (option === 'Edit') openEditModal(row.original);
              if (option === 'Delete') openDeleteModal(row.original);
            }}
          />
        ),
      },
    ],
    [mentors, judges]
  );

  return (
    <div className="text-white min-h-screen overflow-x-auto relative 2xl:w-[1200px] px-4 pt-6">
      <div className="sticky top-4 z-2  p-4 flex flex-col md:flex-row md:items-center md:justify-end rounded-lg shadow-lg mb-6">
        <button
          className="bg-color hover:bg-blue-500 text-white font-bold py-2 px-4 rounded"
          onClick={openForm}
        >
          Add Hackathon Event
        </button>
      </div>

      <Table columns={columns} data={hackathons} />

      {isFormOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-[9999]">
          <div className="bg-white text-black p-6 rounded shadow-lg w-full max-w-lg z-[99999]">
            <HackathonForm onSubmit={handleFormSubmit} onClose={closeForm} />
          </div>
        </div>
      )}

      {showDetailModal && selectedEvent && (
        <ViewHackathonModal
          event={selectedEvent}
          sponsors={sponsors.filter(
            (s) => s.hackathon_form_id === selectedEvent.id
          )}
          firstPrize={firstPrize}
          secondPrize={secondPrize}
          otherPrizes={otherPrizes}
          agendas={agendas} // ✅ pass this
          onClose={closeDetailModal}
        />
      )}

{/* {showEditModal && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <HackathonEditform
            event={selectedEvent}
            onClose={() => setShowEditModal(false)}
          />
        </div>
      )} */}

{showEditModal && (
  <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
    <HackathonEditForm 
      event={selectedEvent}
      prizes={{
        firstPrize,
        secondPrize,
        otherPrizes
      }}
      agendas={agendas}
      onSave={(updatedData) => {
        console.log(updatedData);
        // save updated data to backend
      }}
      onClose={() => setShowEditModal(false)}
    />
  </div>
)}


       {showDeleteModal && (
              <HackathondeleteModal
                event={selectedEvent}
                onClose={() => setShowDeleteModal(false)}
                onDelete={() => {
                  dispatch(deleteHackathon(selectedEvent.id));
                  setShowDeleteModal(false);
                }}
              />
            )}
    </div>
  );
};

export default HackathonEventDetails;